"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DateWrapper = exports.IconWrapper = exports.Date = exports.HiddenInput = exports.CalendarStyle = exports.Wrapper = void 0;

var _reactDateRange = require("react-date-range");

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _polished = require("polished");

var _selectors = require("../../../shared/styles/themes/selectors");

var _styles = require("../../../shared/styles");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n  min-height: 16px;\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  right: 0;\n  top: 50%;\n  transform: translateY(-50%);\n  color: ", ";\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  cursor: pointer;\n  color: ", ";\n  padding: 10px;\n  padding-right: 30px;\n  border-bottom: 2px solid ", ";\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  display: none;\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n          top: 40px;\n        "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n          bottom: 40px;\n        "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  ", "\n  left: 0;\n  z-index: 10;\n  box-shadow: #000 5px 10px 15px;\n  background: ", ";\n  color: ", ";\n  .rdrDayToday .rdrDayNumber span:after {\n    background: ", ";\n  }\n  .rdrDayNumber span {\n    color: ", ";\n  }\n  .rdrWeekDay,\n  .rdrMonthAndYearPickers select {\n    color: ", ";\n  }\n  .rdrDayPassive .rdrDayNumber span {\n    color: ", ";\n  }\n  .rdrNextButton i {\n    border-color: transparent transparent transparent ", ";\n  }\n  .rdrPprevButton i {\n    border-color: transparent ", " transparent transparent;\n  }\n  .rdrNextPrevButton {\n    background: transparent;\n  }\n  .rdrDay:not(.rdrDayPassive) {\n    .rdrInRange,\n    .rdrStartEdge,\n    .rdrEndEdge,\n    .rdrSelected {\n      & ~ .rdrDayNumber {\n        span {\n          color: ", ";\n        }\n      }\n    }\n  }\n  .rdrDayToday:not(.rdrDayPassive) {\n    .rdrInRange,\n    .rdrStartEdge,\n    .rdrEndEdge,\n    .rdrSelected {\n      & ~ .rdrDayNumber span:after {\n        background: ", ";\n      }\n    }\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  color: ", ";\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Wrapper = _styledComponents["default"].div(_templateObject(), _selectors.color, _styles.addCssProp);

exports.Wrapper = Wrapper;
var CalendarStyle = (0, _styledComponents["default"])(_reactDateRange.Calendar)(_templateObject2(), function (_ref) {
  var top = _ref.top;
  return top ? (0, _styledComponents.css)(_templateObject3()) : (0, _styledComponents.css)(_templateObject4());
}, _selectors.secondaryColor, _selectors.color, _selectors.formAccentColor, _selectors.color, function (props) {
  return (0, _polished.transparentize)(0.45, (0, _selectors.color)(props));
}, function (props) {
  return (0, _polished.transparentize)(0.85, (0, _selectors.color)(props));
}, _selectors.color, _selectors.color, function (props) {
  return (0, _polished.transparentize)(0.15, (0, _selectors.secondaryColor)(props));
}, function (props) {
  return (0, _polished.transparentize)(0.15, (0, _selectors.secondaryColor)(props));
});
exports.CalendarStyle = CalendarStyle;

var HiddenInput = _styledComponents["default"].input.attrs({
  type: 'date'
})(_templateObject5());

exports.HiddenInput = HiddenInput;

var Date = _styledComponents["default"].div(_templateObject6(), function (_ref2) {
  var date = _ref2.date,
      rest = _objectWithoutProperties(_ref2, ["date"]);

  return date ? (0, _selectors.color)(rest) : (0, _selectors.getField)('form.placeholderColor', rest);
}, _selectors.formBorderColor);

exports.Date = Date;

var IconWrapper = _styledComponents["default"].div(_templateObject7(), _selectors.color);

exports.IconWrapper = IconWrapper;

var DateWrapper = _styledComponents["default"].div(_templateObject8());

exports.DateWrapper = DateWrapper;